import { Injectable } from '@angular/core';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class CodeIntService {
  private apiSpringUrl = '/spring/codes/ints';

  constructor(private http: HttpService) { }

  get(ownerId: number, typeCd: string, keyCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?oid=${ownerId}&tcd=${typeCd}&&kcd=${keyCd}`;
    return this.http.get(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/code-int/codeint-service.ts